/*!
 * Copyright (c) 2018, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */
import { createApp } from 'vue'
// import { OktaAuth } from '@okta/okta-auth-js'
// import OktaVue from '@okta/okta-vue'
import './polyfills'
import App from './App.vue'
import router from './router'

import 'semantic-ui-css/semantic.min.css'

// import sampleConfig from '@/config'
import msalAuth from "./mixins/msalAuth";
import { msalInstance } from "./authConfig";
import { msalPlugin } from './plugins/msalPlugin'
import store  from './store/index.js'
import { EventType } from "@azure/msal-browser";



// const oktaAuth = new OktaAuth(sampleConfig.oidc)

// oktaAuth.start(); // required for autoRenew

msalInstance.addEventCallback((event) => {
  //logging us in
  if (event.eventType === EventType.LOGIN_SUCCESS && event.payload) {
      const payload = event.payload;
      const account = payload.account;
      msalInstance.setActiveAccount(account);
      const lastLoginDate = new Date().toUTCString();
      // localStorage.setItem("lastLoginDate", new Date().toLocaleString());
      localStorage.setItem("lastLoginDate", lastLoginDate);
  }
});

msalInstance.handleRedirectPromise().then(handleRedirectResponse);

function handleRedirectResponse(response) {
    // let mainUserName = "";

    msalAuth.methods
        .getToken()
        .then(() => {
          // let userResponse = {};
          // let endpoint = store.state.apiEndpoint;
          // let username = store.state.authentication.username;
          if (response !== null) {
            
                setUser(response.account);
                store.state.authentication.authState.isAuthenticated = true;

            } else {
                // In case multiple accounts exist, you can select
                const currentAccounts = msalInstance.getAllAccounts();
                console.log(currentAccounts, "current accountss")
                if (currentAccounts.length === 0) {
                  store.state.authentication.authState.isAuthenticated = false;
                } else if (currentAccounts.length > 0) {
                  store.state.authentication.authState.isAuthenticated = true;
                  setUser(currentAccounts[0]);
                }
              }
              runApp();
        })

}

function setUser(userAccount) {
  store.state.authentication.user = userAccount;
}

function runApp() {
 const app = createApp(App);

 app.use(store);

 app.use(router);
 app.use(msalPlugin, msalInstance);
    // .use(store)
    // .use(router)
    // .use(msalPlugin, msalInstance)
    // .use(OktaVue, {
    //   oktaAuth,
    //   onAuthRequired: () => {
    //     router.push('/login')
    //   },
    //   onAuthResume: () => {
    //     router.push('/login')
    //   },
    // })
    app.mixin(msalAuth)
      .mount('#app')
  
    console.log("App Version 1.21");
}


  
  // console.group('process.env:')
  // console.log(process.env);
  // console.groupEnd()
  
  // // Triggered when a token has expired
  // oktaAuth.tokenManager.on('expired', function (key) { 
  //   console.log('Token with key', key, ' has expired:');
  // });

  // // Triggered when a token has been renewed
  // oktaAuth.tokenManager.on('renewed', function (key) {
  //   console.log('Token with key', key, 'has been renewed');
  // });

